let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a7ymy")).then(() => parcelRequire('g9Hoq'));